"use client";

import type { Server } from "@/lib/servers";
import { useLiveCount } from "./LiveCounts";

// Player count for one server band. Reads the live count from context and
// falls back to 0/0 when no live data is available (server offline, initial
// render before the first poll, etc.).
export default function Players({ s }: { s: Server }) {
  const live = useLiveCount(s.slug);
  const current = live?.online ?? 0;
  const max = live?.max ?? 0;

  return (
    <div className="shrink-0 text-right">
      <div className="font-display text-2xl font-bold tracking-tight xl:text-[32px]">
        <span className="gradient-text">{current}</span>{" "}
        <span className="text-gray-500">/ {max}</span>
      </div>
      <div className="mt-1 text-xs uppercase tracking-[0.12em] text-gray-400">
        Spieler online
      </div>
    </div>
  );
}
